import axios from "axios";
import { KEY, load } from "../cookie";
import { sendToast } from "../utilities/utils";
import { MSG } from "../utilities/constants";

//const TOKEN_TEST = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJmYWtlLXVzZXItaWQiLCJpc3MiOiJWaWVPbiJ9.qryXwT6UmlM61s7RhmUNRR9_7qso5bJKXncmgV_kLS0'
const REACT_APP_CAMPAIGN_ID_RV3_2023 =
  process.env.REACT_APP_CAMPAIGN_ID_RV3_2023;
const API_CAMPAIGNS = process.env.REACT_APP_API_CAMPAIGNS;
const API_VOTE = process.env.REACT_APP_API_VOTE;
const API_STATS = process.env.REACT_APP_API_STATS;
const API_USER_LOGIN = process.env.REACT_APP_API_USER_LOGIN;
const API_USER_PROFILE = process.env.REACT_APP_API_USER_PROFILE;
const API_USER_MBF_PROFILE = process.env.REACT_APP_API_USER_MBF_PROFILE;
const API_USER_ANONYMOUS = process.env.REACT_APP_API_USER_ANONYMOUS;
const API_USER_REFRESH_TOKEN = process.env.REACT_APP_API_USER_REFRESH_TOKEN;

axios.interceptors.request.use(
  (cfg) => {
    if (cfg?.headers) {
      const accessToken = load(KEY.ACCESS_TOKEN) || load(KEY.MBF_ACCESS_TOKEN);
      if (accessToken && !cfg.headers["Authorization"]) {
        cfg.headers["Authorization"] = accessToken;
      }
    }
    return cfg;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const userVote = ({ accessToken, campaignId, objectId, forecastNo }) => {
  const bodyRequest = {
    campaign_id: campaignId || REACT_APP_CAMPAIGN_ID_RV3_2023,
    object_id: objectId,
    forecast_no: Number(forecastNo),
  };
  const config = accessToken
    ? {
        headers: { Authorization: accessToken },
      }
    : null;
  return axios
    .post(API_VOTE, bodyRequest, config)
    .then((res) => res)
    .catch((err) => handleError(err));
};

export const checkStatusCampaign = () =>
  axios
    .get(`${API_CAMPAIGNS}/${REACT_APP_CAMPAIGN_ID_RV3_2023}`)
    .then((res) => res)
    .catch(() => {});

export const checkVote = (accessToken) => {
  const config = accessToken
    ? {
        headers: { Authorization: accessToken },
      }
    : null;
  return axios
    .get(`${API_VOTE}/${REACT_APP_CAMPAIGN_ID_RV3_2023}`, config)
    .then((res) => res)
    .catch((err) => handleError(err));
};

export const getStats = () => axios
  .get(`${API_STATS}/${REACT_APP_CAMPAIGN_ID_RV3_2023}`)
  .then((res) => res)
  .catch(() => sendToast(MSG.ERROR))

export const mobileLogin = ({ phone, password }) => {
  const url = API_USER_LOGIN;
  const bodyParams = {
    username: phone,
    password: password,
    device_id: process.env.REACT_APP_DEVICE_ID,
    country_code: process.env.REACT_APP_COUNTRY,
    model: "",
    push_token: "",
    device_name: "",
    device_type: "",
    platform: process.env.REACT_APP_PLATFORM,
    ui: process.env.REACT_APP_UI_MOBILE,
  };

  const configParams = {
    headers: {
      'Content-Type': 'application/json'
    },
  };
  return axios.post(url, bodyParams, configParams);
};

export const loginAnonymous = () => {
  const url = API_USER_ANONYMOUS;
  const params = {
    device_id: process.env.REACT_APP_DEVICE_ID,
    platform: process.env.REACT_APP_PLATFORM,
    model: "",
    push_token: "",
  };
  const configParams = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  };
  return axios.post(url, params, configParams);
};

export const refreshToken = (accessToken) => {
  const url = API_USER_REFRESH_TOKEN;
  const params = {
    device_id: process.env.REACT_APP_DEVICE_ID,
    platform: process.env.REACT_APP_PLATFORM,
    model: "",
  };
  const configParams = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: accessToken,
    },
  };
  return axios.post(url, params, configParams);
};

export const getUserProfile = (accessToken) => {
  const url = API_USER_PROFILE;
  const config = accessToken
    ? {
        headers: {
          Authorization: accessToken,
        },
      }
    : null;
  return axios
    .get(url, config)
    .then((res) => res)
    .catch((errRes) => errRes);
};

export const getUserMBFProfile = (accessToken) => {
  const url = API_USER_MBF_PROFILE;
  const config = accessToken
    ? {
        headers: { Authorization: accessToken },
      }
    : null;

  return axios
    .post(url, null, config)
    .then((res) => res)
    .catch((errRes) => errRes);
};

export const handleError = (err) => {
  // const code = err?.response?.data?.code;
  // const message = err?.response?.data?.message;

  let messErr = MSG.ERROR;
  // if (code === 400) {
  //   messErr = MSG[message] || MSG.ERROR;
  // }
  sendToast(messErr);
  return err;
};
